export enum StudentProfileTab {
  OVERVIEW = "Overview",
  BY_MODULE = "By Module",
  GRADES_AND_SUBMISSIONS = "Grades & Submissions",
  INTERVENTIONS = "Interventions",
}
